import { createRoute } from "./utils"

const privateRoutes = {
	base: createRoute(`/me`, null, true),

	// Checkout
	// shipping: createRoute('/checkout/shipping', null, true),
	// payment: createRoute('/checkout/payment', null, true),
	// place_order: createRoute('/checkout/place-order', null, true),

	// Orders
	order: createRoute(
		`/order/:orderId`,
		(orderId: string) => `/order/${orderId}`,
		true,
	),

	// Account
	account: createRoute("/me"),
	account_info: createRoute("/settings/profile", null, true),
	account_orders: createRoute("/me/orders", null, true),
	account_addresses: createRoute("/me/addresses", null, true),
}

export default privateRoutes
